(function () {
  var VARIANT_MAP = {
    '382': 53655050617139,
    '383': 53655050813747,
    '384': 53655051010355
  };

  function getCheckedRadio() {
    return document.querySelector('.fk-product-radio:checked');
  }

  function getSelectedVariantId() {
    var checked = getCheckedRadio();
    if (!checked) return null;
    return VARIANT_MAP[checked.value] || null;
  }

  function syncActiveStyling() {
    document.querySelectorAll('.fk-product-radio').forEach(function (radio) {
      var block = radio.parentElement && radio.parentElement.querySelector('.product-selector_block');
      if (!block) return;
      block.classList.toggle('active', radio.checked);
    });
  }

  document.addEventListener('change', function (e) {
    if (e.target.classList && e.target.classList.contains('fk-product-radio')) {
      syncActiveStyling();
    }
  });

  function setAtcLoading(btn, loading) {
    if (!btn) return;
    btn.style.pointerEvents = loading ? 'none' : '';
    btn.style.opacity = loading ? '0.6' : '';
    btn.dataset.originalText = btn.dataset.originalText || btn.textContent;
    btn.textContent = loading ? 'Adding...' : btn.dataset.originalText;
  }

  // Safari/Firefox/Chrome all restore this page from the back-forward
  // cache (bfcache) -- not a fresh reload -- when the customer hits Back
  // from /checkout. That restores the DOM exactly as it was the instant
  // they left, including whatever inline state setAtcLoading(btn, true)
  // left on the ATC button (pointer-events:none, "Adding..." text). With
  // no reset, the button is permanently inert after every back-navigation.
  // event.persisted is true specifically for a bfcache restore, so reset
  // every ATC button's loading state only in that case.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('.product-selector_atc').forEach(function (btn) {
      setAtcLoading(btn, false);
    });
  });

  function addToCartAndCheckout(e) {
    e.preventDefault();
    var btn = e.currentTarget;
    var checked = getCheckedRadio();
    var variantId = checked ? VARIANT_MAP[checked.value] : null;
    if (!variantId) {
      alert('Please select an offer above.');
      return;
    }
    setAtcLoading(btn, true);
    // This page sells mutually-exclusive bundle tiers (one variant IS the
    // whole offer), not add-on quantities -- clear any previously added
    // tier before adding the newly selected one so the cart never ends up
    // with more than one tier's line item at once.
    fetch('/cart/clear.js', { method: 'POST' })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
      })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || 'Could not add to cart');
          return data;
        });
      })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        setAtcLoading(btn, false);
        alert(err.message);
      });
  }

  // Generic accordion: thumbSelector click toggles .active on the closest
  // blockSelector ancestor and shows/hides its contentSelector child.
  // Covers FAQ, ingredient tabs, and "Inside Each Scoop" blocks -- none of
  // these have a JS-free CSS reveal rule (only icon-rotate/border styling
  // is class-driven), so the show/hide itself has to be done in JS.
  function wireAccordion(thumbSelector, blockSelector, contentSelector) {
    document.querySelectorAll(thumbSelector).forEach(function (thumb) {
      thumb.style.cursor = 'pointer';
      thumb.addEventListener('click', function () {
        var block = thumb.closest(blockSelector);
        if (!block) return;
        var content = block.querySelector(contentSelector);
        var opening = !block.classList.contains('active');
        block.classList.toggle('active', opening);
        if (content) content.style.display = opening ? 'block' : 'none';
      });
    });
  }

  function wireNutritionPopup() {
    var trigger = document.querySelector('.main_product-nutrition-info');
    var popup = document.querySelector('.nutrition_popup-outer');
    if (!trigger || !popup) return;
    trigger.style.cursor = 'pointer';
    trigger.addEventListener('click', function () {
      popup.style.display = 'flex';
    });
    popup.addEventListener('click', function (e) {
      if (e.target === popup || e.target.classList.contains('nutrition_popup-close')) {
        popup.style.display = 'none';
      }
    });
  }

  // Mobile hero image slider: thumbnail click scrolls the viewport to that
  // slide, and the active thumb/dot stays in sync while the user swipes.
  function wireMobileSlider() {
    var viewport = document.getElementById('csViewport');
    var thumbs = document.querySelectorAll('.cs-thumb');
    var slides = document.querySelectorAll('.cs-slide');
    var dotsContainer = document.getElementById('csDots');
    if (!viewport || !slides.length) return;

    if (dotsContainer && !dotsContainer.children.length) {
      slides.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.className = 'cs-dot' + (i === 0 ? ' cs-dot-active' : '');
        dot.setAttribute('aria-label', 'Go to image ' + (i + 1));
        dot.addEventListener('click', function () { scrollToSlide(i); });
        dotsContainer.appendChild(dot);
      });
    }
    var dots = dotsContainer ? dotsContainer.querySelectorAll('.cs-dot') : [];

    function setActiveIndex(i) {
      thumbs.forEach(function (t, idx) { t.classList.toggle('cs-thumb-active', idx === i); });
      dots.forEach(function (d, idx) { d.classList.toggle('cs-dot-active', idx === i); });
    }

    function scrollToSlide(i) {
      var slide = slides[i];
      if (!slide) return;
      viewport.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      setActiveIndex(i);
    }

    thumbs.forEach(function (thumb, i) {
      thumb.style.cursor = 'pointer';
      thumb.addEventListener('click', function () { scrollToSlide(i); });
    });

    var scrollTimeout;
    viewport.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function () {
        var i = Math.round(viewport.scrollLeft / viewport.clientWidth);
        i = Math.max(0, Math.min(slides.length - 1, i));
        setActiveIndex(i);
      }, 100);
    });
  }

  // Judge.me review photo thumbnails: the static HTML snapshot ships each
  // one stuck in Judge.me's own "jdgm--loading" placeholder state (a grey
  // broken-image icon) because the real thumbnail URL only gets swapped in
  // by Judge.me's live API-backed lazy-load, which never fires against a
  // static snapshot. The real URL is already present on the link's
  // data-mfp-src attribute, so just promote it straight into the img src.
  // A MutationObserver keeps this applied as Judge.me re-renders the
  // review list (pagination, sorting, filtering).
  function fixReviewPhotoThumbnails(root) {
    (root || document).querySelectorAll('.jdgm-rev__pic-link.jdgm--loading').forEach(function (link) {
      var realSrc = link.getAttribute('data-mfp-src');
      var img = link.querySelector('.jdgm-rev__pic-img');
      if (!realSrc || !img) return;
      img.src = realSrc;
      link.classList.remove('jdgm--loading');
    });
  }

  function wireReviewPhotoFix() {
    var widg = document.querySelector('.jdgm-rev-widg');
    if (!widg) return;
    fixReviewPhotoThumbnails(widg);
    var observer = new MutationObserver(function () {
      fixReviewPhotoThumbnails(widg);
    });
    observer.observe(widg, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    syncActiveStyling();
    document.querySelectorAll('.product-selector_atc').forEach(function (btn) {
      btn.addEventListener('click', addToCartAndCheckout);
    });
    wireAccordion('.product_faq-thumb', '.product_faq-box', '.product_faq-content');
    wireAccordion('.product_tab-thumb', '.product_tab-block', '.product_tab-content');
    wireAccordion('.product-inside_block-thumb', '.product-inside_block', '.product-inside_block-content');
    wireNutritionPopup();
    wireMobileSlider();
    wireReviewPhotoFix();
  });
})();
